'use strict';

var getPolicy = function getPolicy(consentPolicyGetter) {
  return typeof consentPolicyGetter === 'function' && consentPolicyGetter();
};

var shouldMuteNonEssentials = function shouldMuteNonEssentials(consentPolicyGetter) {
  var policy = getPolicy(consentPolicyGetter);

  if (!policy) {
    return false;
  }

  return policy.functional === false || policy.analytics === false;
};

var shouldMuteByCategory = function shouldMuteByCategory(consentPolicyGetter, category) {
  var policy = getPolicy(consentPolicyGetter);

  if (!policy || category === 'essential') {
    return false;
  }

  if (category === 'functional' || category === 'analytics') {
    return policy[category] === false;
  }

  return shouldMuteNonEssentials(consentPolicyGetter);
};

module.exports = {
  shouldMuteNonEssentials: shouldMuteNonEssentials,
  shouldMuteByCategory: shouldMuteByCategory
};
//# sourceMappingURL=consent-policy.js.map